<!-- <footer class="container-fluid footer-area d-flex justify-content-between">
  <p>&copy;2021 NSDA</p>
  <p class="float-end">Developed by <a href="https://synesisit.com.bd/">Synesis IT</a></p>
</footer> -->
<nz-footer class="container-fluid footer-area d-flex justify-content-between">{{copywriteNotice}}
  <p class="float-end">Developed by <a href="https://synesisit.com.bd/">Synesis IT</a></p>

</nz-footer>